import {RenderAuditLogsEnrichment, RendererProps} from "../RendererProps";
import {MinimalProperty} from "../../../../../contexts/properties/logic";
import {ReactElement, useMemo} from "react";
import {ensureNotObject} from "../common";
import {formatterEnumToTitle} from "../../../../../utils/formatters";
import {authorizationTitleRemapping} from "../../../users/logic/authorizationRenamer";
import * as common from "../styles/common.module.scss";

export interface RenderCreateUpdateUserProps extends RendererProps {
    properties: MinimalProperty[];
    enrichment?: RenderAuditLogsEnrichment
}

export function RenderCreateUpdateUser(props: RenderCreateUpdateUserProps): ReactElement {
    const firstName = props.variables["firstName"];
    const lastName = props.variables["lastName"];
    const email = props.variables["email"];
    const isReadOnly = props.variables["isReadOnly"];
    const role = props.variables["role"];
    const generatePassword = props.variables["generatePassword"];

    const properties = props.variables["properties"];
    const authorizations = props.variables["authorizations"];
    const groups = props.variables["groups"];

    const userGroupsMap = useMemo(() => {
        if(props.enrichment) {
            return props.enrichment.userGroups.toIdMap(g => g.id);
        }
        return {};
    }, [props.enrichment]);

    const propertiesMap = useMemo(() => {
        return props.properties.toIdMap(p => p.id);
    }, [props.properties]);

    let propertyNames: string[] = [];
    if(Array.isArray(properties) && properties.length > 0) {
        propertyNames = properties.map(p => {
            if(typeof p === "string") {
                return propertiesMap[p]?.name ?? "Unknown";
            }
            return "Unknown";
        });
    }

    let authNames: string[] = [];
    if(Array.isArray(authorizations) && authorizations.length > 0) {
        authNames = authorizations.map(a => formatterEnumToTitle(authorizationTitleRemapping(a)));
    }

    let groupNames: string[] = [];
    if(Array.isArray(groups) && groups.length > 0) {
        groupNames = groups.map(g => {
            if(typeof g === "string") {
                return userGroupsMap[g]?.name ?? "Unknown";
            }
            return "Unknown";
        });
    }

    return <div>
        <h5 className={common.textHeader}>User Info</h5>
        <div>
            <div className={common.section}>Name: {ensureNotObject(firstName)} {ensureNotObject(lastName)}</div>
            <div className={common.section}>Email: {ensureNotObject(email)}</div>
            {isReadOnly && <div className={common.section}>Read Only</div>}
            <div className={common.section}>Role: {ensureNotObject(role)}</div>
            {generatePassword && <div className={common.section}>Generated Password</div>}
            <div className={common.section}>Properties: {propertyNames.join(", ")}</div>
            <div className={common.section}>Authorizations: {authNames.join(", ")}</div>
            <div className={common.section}>Groups: {groupNames.join(", ")}</div>
        </div>
    </div>;
}